import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_safe_use_scaffolding_i_e_secured_permanent'

export const dataPointDefinition = {
  retracedId: 'no_safe_use_scaffolding_i_e_secured_permanent',
  name: 'No safe use of scaffolding (i.e. secured to a permanent structure, able to carry intended load etc.)',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-con-6x',
      number: 'HS-CON-2-4',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-con-2',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-54,Yes',
      machineShowHide: '[2],hs-54,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-con-6x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30550,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
